<div class="row mt-3 ml-lg-2 mr-lg-2">
  <div class="col-12">
    <div>
      <h3 class="d-inline-block mb-2">
        <span class="fa-light fa-fw fa-users"></span>
        {{ "RECEIVER_TEAMS" | translate }}
      </h3>
      <div class="mb-2">
        <span class="fa-solid fa-user fa-fw staffSuperUser"></span>
        <small> = {{ "STAFF_CUSTOMER_ADMIN" | translate }}</small>

        <span class="fa-light fa-user fa-fw staffMainUser ml-2"></span>
        <small> = {{ "STAFF_MAIN_USER" | translate }}</small>

        <span class="fa-light fa-user fa-fw staffUser ml-2"></span>
        <small> = {{ "STAFF_USER" | translate }}</small>

        <span class="fa-light fa-user fa-fw ml-2"></span>
        <small> = {{ "STAFF_READONLY" | translate }}</small>

        @if (featureEnabled('EveronMobileApp')) {
          <span class="fa-light fa-user fa-fw ml-2 staffEMA"></span>
        }
        @if (featureEnabled('EveronMobileApp')) {
          <small>
            = {{ "EveronMobileApp" | translate }}
          </small>
        }

        @if (featureEnabled('AnnaPerenna') || featureEnabled('OnOn')) {
          <span class="fa-light fa-user fa-fw ml-2 staffAPMU"></span>
        }
        @if (featureEnabled('AnnaPerenna') || featureEnabled('OnOn')) {
          <small>
            = {{ "STAFF_ONON_MAIN_USER" | translate }}
          </small>
        }
      </div>
      @if (user.roleLevel >= 100) {
        <div class="mb-3 mt-3">
          <button
            class="btn btn-primary"
            (click)="showTeamEditForm = false; showTeamAddForm = true"
            >
            <span class="fa-light fw fa-plus"></span>
            {{ "CREATE_NEW_GROUP" | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</div>
<div class="row mt-3 ml-xl-2 mr-xl-2">
  <div [ngClass]="{ 'd-none d-lg-block': isSideFormVisible(), 'col-xl-8 col-lg-7': isSideFormVisible(), 'col-xl-12': !isSideFormVisible() }">
    @if (noTeamsAvailable) {
      <h6 class="noUsers">
        {{ "NO_RECEIVER_TEAMS_AVAILABLE" | translate }}
      </h6>
    }
    <!--Customer groups-->
    @for (customerGroup of customerTeams; track customerGroup) {
      <div class="card-group">
        <div class="card mb-4">
          <div class="card-header cursorPointer" (click)="customerGroup.collapsed = !customerGroup.collapsed">
            <h5>
              <span [ngClass]="customerGroup.collapsed ? 'fa-light fa-fw fa-user' : 'fas fa-fw fa-user'"></span>
              {{ customerGroup.customerName }}
            </h5>
            <small>
              {{ "NR_OF_GROUPS" | translate }}:
              {{ customerGroup.teams ? customerGroup.teams.length : 0 }}
            </small>
          </div>
          @if (customerGroup.collapsed) {
            <div class="body-overline">
              <div class="card-body">
                @if (receiverTeams) {
                  <div class="row pl-2 pr-2 pt-2">
                    @for (team of customerGroup.teams; track team) {
                      <div>
                        <div
                          class="card group-container mx-2"
                          [ngClass]="{ userLoggedInCard: team.currentUserLoggedToThisGroup, userLoggedOutCard: !team.currentUserLoggedToThisGroup, hiddenTeam: team.hidden }"
                          >
                          <div
                            class="card-header cursorPointer"
                            [ngClass]="{ hiddenTeam: team.hidden }"
                            (click)="team.collapsed = !team.collapsed"
                            >
                            <div class="d-flex justify-content-between align-items-baseline">
                              <h6 class="d-flex flex-grow-1">
                                <span class="fa-solid fa-fw fa-users mr-3"></span>
                                <span>
                                  {{ team.groupName.length > 15 ? team.groupName.slice(0, 15) + "..." : team.groupName }}
                                </span>
                                @if (team.locked) {
                                  <span
                                    class="fa-light fa-fw fa-lock ml-1"
                                  ></span>
                                }
                              </h6>
                              <!--Button for group edit-->
                              @if (team.hidden) {
                                <span
                                  matTooltip="{{ 'HIDDEN' | translate }}"
                                  matTooltipClass="receiverGroupTooltip"
                                  class="float-right fa-sharp fa-light fa-eye-slash fa-lg mr-2"
                                ></span>
                              }
                              @if (user.roleLevel >= 50) {
                                <span
                                  matTooltip="{{ 'TOOLTIP_EDIT_RECEIVER_TEAM' | translate }}"
                                  matTooltipClass="receiverGroupTooltip"
                                  data-testid="edit-customer-receiver-team"
                                  class="fa-light fa-pen-to-square fa-lg mr-2 cursorPointerHover"
                                                (click)="
                                                    showTeamInformation(team);
                                                    showLocationEditForm = false;
                                                    showTeamAddForm = false;
                                                    $event.stopPropagation()
                                                "
                                ></span>
                              }
                              <!--Button to mark user active or inactive-->
                              @if (user.roleLevel <= 100 && !team.locked && team.currentUserLoggedToThisGroup) {
                                <span
                                  (click)="changeUserGroupActiveStatus(team)"
                                  class="cursorPointer float-right mr-2 ml-1 fa-light fa-fw fa-lg"
                                  [matTooltip]="team.currentUserActiveInThisGroup ? ('GROUP_MARK_INACTIVE' | translate) : ('GROUP_MARK_ACTIVE' | translate)"
                                  matTooltipClass="receiverGroupTooltip"
                                  [ngClass]="team.currentUserActiveInThisGroup ? 'fa-volume-slash userLoggedIn' : 'fa-volume userLoggedOut'"
                                ></span>
                              }
                              <!--Button to join or leave group-->
                              @if (user.roleLevel <= 100 && !team.locked) {
                                <span
                                  class="cursorPointer float-right mr-2 ml-1"
                                  [matTooltip]="team.currentUserLoggedToThisGroup ? ('REMOVE_USER_FROM_GROUP' | translate) : ('ADD_USER_TO_GROUP' | translate)"
                                  matTooltipClass="receiverGroupTooltip"
                                  [ngClass]="team.currentUserLoggedToThisGroup ? 'fa-light fa-user-minus fa-lg userLoggedIn' : 'fa-light fa-user-plus fa-lg userLoggedOut'"
                                                (click)="
                                                    team.currentUserLoggedToThisGroup ? removeUserFromGroup(team.groupId) : addUserToGroup(team.groupId);
                                                    $event.stopPropagation()
                                                "
                                ></span>
                              }
                            </div>
                            <small>{{ "NR_OF_STAFF_IN_GROUP" | translate }}: {{ team.users ? team.users.length : 0 }}</small>
                          </div>
                          @if (team.users.length === 0) {
                            <p class="noUsers">
                              {{ "NO_USERS_IN_RECEIVER_TEAM" | translate }}
                            </p>
                          }
                          @if (team.users.length > 0) {
                            <div>
                              @if (team.collapsed) {
                                <table
                                  class="table table-borderless table-responsive-sm"
                                  >
                                  <thead>
                                    <tr class="border-bottom">
                                      <th>#</th>
                                      <th>{{ "NAME" | translate }}</th>
                                      @if (emaFeatureEnabled()) {
                                        <th>
                                          EMA
                                          <span
                                            matTooltip="{{ 'TOOLTIP_EMA' | translate}}"
                                            matTooltipClass="receiverGroupTooltip"
                                            class="fa fa-fw fa-info-circle"
                                          ></span>
                                        </th>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (user of team.users; track user) {
                                      <tr>
                                        <td>
                                          <span
                                            class="fa-user fa-fw fa-lg"
                                            [ngClass]="[getUsingLevelClass(user.usingLevel), user.usingLevel === 101 ? 'fa-solid' : 'fa-light']">
                                          </span>
                                        </td>
                                        <td class="staff" [ngClass]="{inactiveMember: getInactiveState(user) }">
                                          <span (click)="openPersonnelPage(user.id)" class="cursorPointerHover">
                                            {{ user.name.length > 20 ? user.name.slice(0, 20) + "..." : user.name }}
                                          </span>
                                          {{ user.id }}
                                        </td>
                                        @if (emaFeatureEnabled()) {
                                          <td>
                                            @if (!user.emaOnline) {
                                              <i class="fa-regular fa-circle mr-2 emaOffline"></i>
                                            }
                                            @if (user.emaOnline) {
                                              <i class="fa-solid fa-circle-check mr-2 emaOnline"></i>
                                            }
                                          </td>
                                        }
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    <!--Location groups-->
    @for (locationGroup of locationTeams; track locationGroup) {
      <div class="card-group">
        <div class="card mb-4">
          <div class="card-header cursorPointer" (click)="locationGroup.collapsed = !locationGroup.collapsed">
            <h5>
              <span [ngClass]="locationGroup.collapsed ? 'fa-fw fa-light fa-house' : ' fa-fw fa-solid fa-house'"></span>
              {{ locationGroup.locationName }}
              @if (user.roleLevel >= 100) {
                <span
                  class="float-right fa-light fa-pen-to-square mr-2 cursorPointerHover"
                  matTooltip="{{ 'TOOLTIP_EDIT_LOCATION' | translate }}"
                  matTooltipClass="receiverGroupTooltip"
                            (click)="
                                getLocationInformation(locationGroup.locationId);
                                showTeamAddForm = false;
                                showTeamEditForm = false;
                                showLocationEditForm = true;
                                $event.stopPropagation()
                            "
                ></span>
              }
            </h5>
            <small>
              {{ "NR_OF_GROUPS" | translate }}: {{ locationGroup.teams ? locationGroup.teams.length : 0 }}
            </small>
          </div>
          @if (locationGroup.collapsed) {
            <div class="body-overline">
              <div class="card-body">
                @if (receiverTeams) {
                  <div class="row pl-2 pr-2 pt-2">
                    <!-- [ngClass]="isSideFormVisible() ? 'col-xl-4 col-lg-6 col-md-7' : 'col-xl-3 col-lg-4 col-md-6' " -->
                    @for (team of locationGroup.teams; track team) {
                      <div>
                        <div
                          class="card group-container mx-2"
                          [ngClass]="{ userLoggedInCard: team.currentUserLoggedToThisGroup, userLoggedOutCard: !team.currentUserLoggedToThisGroup, hiddenTeam: team.hidden }"
                          >
                          <div
                            class="card-header cursorPointer"
                            [ngClass]="{ hiddenTeam: team.hidden }"
                            (click)="team.collapsed = !team.collapsed"
                            >
                            <div class="d-flex justify-content-between align-items-baseline">
                              <h6 class="d-flex flex-grow-1">
                                <span class="fa-solid fa-fw fa-users mr-3"></span>
                                <span>{{ team.groupName.length > 15 ? team.groupName.slice(0, 15) + "..." : team.groupName }}</span>
                                @if (team.locked) {
                                  <span class="fa-light fa-fw fa-lock ml-1"></span>
                                }
                              </h6>
                              <!--Button for group edit-->
                              @if (team.hidden) {
                                <span
                                  matTooltip="{{ 'HIDDEN' | translate }}"
                                  matTooltipClass="receiverGroupTooltip"
                                  class="float-right fa-sharp fa-light fa-eye-slash fa-lg mr-2"
                                ></span>
                              }
                              @if (user.roleLevel >= 50) {
                                <span
                                  matTooltip="{{ 'TOOLTIP_EDIT_RECEIVER_TEAM' | translate }}"
                                  matTooltipClass="receiverGroupTooltip"
                                  data-testid="edit-location-receiver-team"
                                  class="float-right fa-light fa-pen-to-square fa-lg mr-2 cursorPointerHover"
                                                (click)="
                                                    showTeamInformation(team);
                                                    showLocationEditForm = false;
                                                    showTeamAddForm = false;
                                                    $event.stopPropagation()
                                                "
                                ></span>
                              }
                              <!--Button to mark user active or inactive-->
                              @if (user.roleLevel <= 100 && !team.locked && team.currentUserLoggedToThisGroup) {
                                <span
                                  class="cursorPointer float-right mr-2 ml-1 fa-light fa-fw fa-lg"
                                  matTooltipClass="receiverGroupTooltip"
                                  [matTooltip]="team.currentUserActiveInThisGroup ? ('GROUP_MARK_INACTIVE' | translate) : ('GROUP_MARK_ACTIVE' | translate)"
                                  [ngClass]="team.currentUserActiveInThisGroup ? 'fa-volume-slash userLoggedIn' : 'fa-volume userLoggedOut'"
                                  (click)="changeUserGroupActiveStatus(team)"
                                ></span>
                              }
                              <!--Button to join or leave group-->
                              @if (user.roleLevel <= 100 && !team.locked) {
                                <span
                                  class="cursorPointer float-right mr-2 ml-1"
                                  [matTooltip]="team.currentUserLoggedToThisGroup ? ('REMOVE_USER_FROM_GROUP' | translate) : ('ADD_USER_TO_GROUP' | translate)"
                                  matTooltipClass="receiverGroupTooltip"
                                  [ngClass]="team.currentUserLoggedToThisGroup ? 'fa-light fa-user-minus fa-lg userLoggedIn' : 'fa-light fa-user-plus fa-lg userLoggedOut'"
                                                (click)="
                                                    team.currentUserLoggedToThisGroup ? removeUserFromGroup(team.groupId) : addUserToGroup(team.groupId);
                                                    $event.stopPropagation()
                                                "
                                ></span>
                              }
                            </div>
                            <small>
                              {{ "NR_OF_STAFF_IN_GROUP" | translate }}:
                              {{ team.users ? team.users.length : 0 }}
                            </small>
                          </div>
                          @if (team.users.length === 0) {
                            <p class="noUsers">
                              {{ "NO_USERS_IN_RECEIVER_TEAM" | translate }}
                            </p>
                          }
                          @if (team.users.length > 0) {
                            <div>
                              @if (team.collapsed) {
                                <table class="table table-borderless table-responsive-sm">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th>#</th>
                                      <th>{{ "NAME" | translate }}</th>
                                      @if (emaFeatureEnabled()) {
                                        <th>
                                          EMA
                                          <span
                                            matTooltip="{{ 'TOOLTIP_EMA' | translate }}"
                                            matTooltipClass="receiverGroupTooltip"
                                            class="fa fa-fw fa-info-circle"
                                          ></span>
                                        </th>
                                      }
                                    </tr>
                                  </thead>
                                  <tbody>
                                    @for (user of team.users; track user) {
                                      <tr>
                                        <td>
                                          <span
                                            class="fa-user fa-fw fa-lg"
                                            [ngClass]="[getUsingLevelClass(user.usingLevel), user.usingLevel === 101 ? 'fa-solid' : 'fa-light']">
                                          </span>
                                        </td>
                                        <td class="staff" [ngClass]="{ inactiveMember: getInactiveState(user)}">
                                          <span (click)="openPersonnelPage(user.id)" class="cursorPointerHover">
                                            {{ user.name.length > 20 ? user.name.slice(0, 20) + "..." : user.name }}
                                          </span>
                                          {{ user.id }}
                                        </td>
                                        @if (emaFeatureEnabled()) {
                                          <td>
                                            @if (!user.emaOnline) {
                                              <i class="fa-regular fa-circle mr-2 emaOffline"></i>
                                            }
                                            @if (user.emaOnline) {
                                              <i class="fa-solid fa-circle-check mr-2 emaOnline"></i>
                                            }
                                          </td>
                                        }
                                      </tr>
                                    }
                                  </tbody>
                                </table>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (!receiverTeams && !noTeamsAvailable) {
      <div>
        <img class="fadeLoader centerLoader logoSmall mt-2" src="assets/img/loading_logo.svg"/>
      </div>
    }
  </div>
  @if (showTeamEditForm) {
    <div class="col-xl-4 col-lg-5">
      <team-edit
        (closeEditFormEvent)="closeTeamInformationForm()"
        [locations]="allLocations"
        [staff]="allStaff"
        [team]="selectedTeam"
        (teamEdited)="teamsModified()"
        (teamDeleted)="teamDeleted($event)"
      ></team-edit>
    </div>
  }
  @if (showTeamAddForm) {
    <div class="col-xl-4 col-lg-5">
      <team-add
        (closeAddFormEvent)="showTeamAddForm = false"
        [staff]="allStaff"
        (teamAdded)="teamsModified()"
        >
      </team-add>
    </div>
  }
  @if (showLocationEditForm && selectedLocation) {
    <div
      class="col-xl-4 col-lg-5"
      >
      <location-info
        [location]="selectedLocation"
        (closeLocationCardEvent)="showLocationEditForm = false; selectedLocation = null"
        (locationUpdateEvent)="locationEdited()"
      ></location-info>
    </div>
  }
  @if (showLocationEditForm && !selectedLocation) {
    <div class="col-xl-4 col-lg-5">
      <img
        class="fadeLoader centerLoader logoSmall mt-2"
        src="assets/img/loading_logo.svg"
        />
      </div>
    }
  </div>
